"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toArrayValues = exports.toArrayValue = exports.addValue = exports.addToValues = exports.overrideValues = exports.setValue = exports.normalizeValues = exports.normalizeValue = exports.getValue = exports.getLastValue = exports.findKey = void 0;
/**
 * Does a case-insensitive search for a key and returns the original case or
 * undefined if not found.
 */
function findKey(headers, key) {
    key = key.toLowerCase();
    for (const header in headers) {
        if (key === header.toLowerCase()) {
            return header;
        }
    }
}
exports.findKey = findKey;
/**
 * Get the last value for a given `key` in a map of arrays.
 */
function getLastValue(values, key) {
    const actualKey = findKey(values, key);
    if (actualKey) {
        const value = values[actualKey];
        return Array.isArray(value) ? value[value.length - 1] : value;
    }
}
exports.getLastValue = getLastValue;
/**
 * Does a case-insensitive search for a `key` and returns the value if it
 * exists.
 */
function getValue(values, key) {
    const actualKey = findKey(values, key);
    if (actualKey) {
        return values[actualKey];
    }
}
exports.getValue = getValue;
/**
 * If `value` has zero elements, return undefined; if value has 1 element,
 * return the element; and otherwise return the array.
 */
function normalizeValue(value) {
    if (value.length > 1) {
        return value;
    }
    if (value.length === 1) {
        return value[0];
    }
}
exports.normalizeValue = normalizeValue;
/**
 * For a map with array values, returns the result of calling `normalizeValue()`
 * for each value, removing undefined values.
 */
function normalizeValues(values) {
    return Object.keys(values).reduce((a, x) => {
        const v = normalizeValue(values[x]);
        return v ? { ...a, [x]: v } : a;
    }, {});
}
exports.normalizeValues = normalizeValues;
/**
 * Set a value in a collection with a case-insensitive key lookup.
 */
function setValue(values, key, value) {
    const actualKey = findKey(values, key) || key;
    return { ...values, [actualKey]: value };
}
exports.setValue = setValue;
/**
 * Process the collections from left to right, with later values overriding
 * earlier ones.
 */
function overrideValues(...collections) {
    return collections.reduce((merged, current) => Object.keys(current).reduce((headers, key) => setValue(headers, key, current[key]), merged), {});
}
exports.overrideValues = overrideValues;
/**
 * Adds `value` to the end of the `values` array, returning a new instead of
 * modifying the original.
 */
function addToValues(values, value) {
    if (values) {
        if (Array.isArray(values)) {
            return values.concat(value);
        }
        return [values, value];
    }
    return value;
}
exports.addToValues = addToValues;
/**
 * Adds a `value` to a `key`, which may or may not already exist.
 */
function addValue(values, key, value) {
    const actualKey = findKey(values, key) || key;
    return { ...values, [actualKey]: addToValues(values[actualKey], value) };
}
exports.addValue = addValue;
/**
 * Ensure that `value` is an array.
 */
function toArrayValue(value) {
    return Array.isArray(value) ? value : [value];
}
exports.toArrayValue = toArrayValue;
/**
 * Convert each value in the map into an array.
 */
function toArrayValues(values) {
    return Object.keys(values).reduce((a, x) => ({ ...a, [x]: toArrayValue(values[x]) }), {});
}
exports.toArrayValues = toArrayValues;
//# sourceMappingURL=HttpValueCollection.js.map